import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      this.cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0].CUTOFF))
      
      let json = JSON.parse(JSON.stringify(this.JQueries))

      // ##### JSON #####
      this.title      = json.title
      this.timeline   = json.timeline
      this.legends    = json.legends
      this.primary    = json.primary
      this.chart      = json.chart
      this.sundries   = json.sundries
      this.keys       = json.keys
      this.filters    = json.filters

      this.timeline = {...this.timeline, 
        week : [],
        month: [],
        year: [],
        axis: null,
        band: null,
      }
      this.primary.axis = null
      this.primary.max = null


      // // Calculate the Height of Canvas
      // this.Canvas.CanvasWidth = this.chart.width + this.chart.x * 2
      // this.Canvas.CanvasHeight = this.chart.height + this.chart.y + 40


      // Setting Timeline ----------------------------
      this.timeline.axis = d3.scaleBand()
      .domain(this.chartData.map(d => d.CDATE ))
      .range([0, this.chart.width])
      this.timeline.band = this.timeline.axis.bandwidth()

      this.gmx_BandScaleValues_Week(this.chartData)

      // Set Coordinates for Bar X -------------------
      this.chartData.forEach((d,i)=> {
        d.bxs = this.gmx_BarCoordinates(d.mx, [...this.chart.styles.map(m => m.size)], this.chart.barGap)
      })
      

      // Setting Primary 
      let maxArray = []
      this.chart.styles.forEach((s,i)=> {
        maxArray.push(d3.max(this.chartData, c => c[s.code]))
      })

      this.primary.max = d3.max(maxArray)
      this.primary.max = this.gmx_maxBound5(this.primary.max)

      this.primary.max = this.gmx_maxBound5(this.primary.max)
      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range(this.primary.type == 'LINE' ? [this.chart.height,0] : [0, this.chart.height])

      this.primary.titleX = -this.primary.padding

    },


  }
}